export default "__VITE_ASSET__B$LJtT9Q__"